import { shippingAddressStyles as styles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import { css } from "styled-components";

styles.addressDisplay = {
    ...styles.addressDisplay,
    wrapper: {
        css: css`
            margin: 10px 0 -10px 10px;
        `,
    },
};
